import { ToastContainer as DSToastContainer } from '@lean-agility/design-system/react';
import { useErrorContext } from '@/contexts/useErrorContext';

/**
 * Connected toast container that renders all active toasts from ErrorContext.
 * Delegates rendering to the shared design system ToastContainer.
 */
export function ToastContainer() {
  const { errors, dismissError } = useErrorContext();
  return <DSToastContainer toasts={errors} onDismiss={dismissError} />;
}
